var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: _vm.messageData.width,
            title: _vm.messageData.title,
            "before-close": _vm.handleClose,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "mt20",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _vm.messageData.type !== 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "提醒时间：", prop: "date" } },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          format: "HH:mm",
                          "value-format": "HH:mm",
                          size: "small",
                          clearable: "",
                          placeholder: "选择提醒时间",
                        },
                        model: {
                          value: _vm.form.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "date", $$v)
                          },
                          expression: "form.date",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.messageData.type == 1
                ? _c("el-form-item", { attrs: { label: "提醒时间：" } }, [
                    _c("div", { staticClass: "item" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.messageData.data.template_type == "clock_remind"
                              ? "上班前"
                              : "下班后"
                          ) +
                          "\n\n          "
                      ),
                      _c(
                        "div",
                        { staticClass: "mo-input--number" },
                        [
                          _c("el-input-number", {
                            attrs: {
                              "controls-position": "right",
                              size: "small",
                              min: 0,
                            },
                            model: {
                              value: _vm.hour,
                              callback: function ($$v) {
                                _vm.hour = $$v
                              },
                              expression: "hour",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "define-append" }, [
                            _vm._v("小时"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mo-input--number" },
                        [
                          _c("el-input-number", {
                            attrs: {
                              "controls-position": "right",
                              size: "small",
                              min: 0,
                            },
                            model: {
                              value: _vm.minute,
                              callback: function ($$v) {
                                _vm.minute = $$v
                              },
                              expression: "minute",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "define-append" }, [
                            _vm._v("分钟"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.messageData.data.template_type == "clock_remind"
                              ? "进行上班打卡"
                              : "进行下班打卡"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.handleClose()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loading,
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }